import Pokedex from './components/Pokedex';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Pokedex />
    </div>
  );
}

export default App;
